import { post } from "./CallApi";
import { attachment_URL } from "../../Constants";
export function isAuthenticated() {
  return window.sessionStorage.getItem("userInfo") ? true : false;
}

export function logout() {
  localStorage.removeItem("loginToken");
  window.sessionStorage.removeItem("userInfo");
  localStorage.removeItem("companyId");
  window.location.replace("/");
}

export function getToken() {
  try {
    return localStorage.getItem("loginToken");
  } catch {
    return null;
  }
}

export function isSuperAdmin() {
  try {
    return JSON.parse(window.sessionStorage.getItem("userInfo")).isSuperAdmin ==
      "1"
      ? true
      : false;
  } catch {
    logout();
  }
}

export function getOrganizationId() {
  if (!window.sessionStorage.getItem("userInfo")) return null;
  return JSON.parse(window.sessionStorage.getItem("userInfo")).organization
    ? JSON.parse(window.sessionStorage.getItem("userInfo")).organization["id"]
    : null;
}

export function isCompanyOwner() {
  const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
  const groupsArray = Object.values(userInfo.groups)[0];
  const groupType = groupsArray[0].name;
  if (groupType && groupType === "Organization Admin") {
    return true;
  }
  return false;
}

export function getEmail() {
  return JSON.parse(window.sessionStorage.getItem("userInfo")).email;
}
export function getFirstName() {
  return window.sessionStorage.getItem("userInfo")
    ? JSON.parse(window.sessionStorage.getItem("userInfo")).firstName
    : null;
}

export function getLastName() {
  return JSON.parse(window.sessionStorage.getItem("userInfo")).lastName;
}

export function getPosition() {
  return JSON.parse(window.sessionStorage.getItem("userInfo")).position;
}

export function addOrgID(orgId) {
  const existingUserInfo =
    JSON.parse(window.sessionStorage.getItem("userInfo")) || {};

  existingUserInfo.organization = {
    ...existingUserInfo.organization,
    id: parseInt(orgId),
  };

  const updatedUserInfo = {
    ...existingUserInfo,
  };

  window.sessionStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
}

export function removeOrgIdFromCookie() {
  const existingUserInfo =
    JSON.parse(window.sessionStorage.getItem("userInfo")) || {};

  if (existingUserInfo.organization) {
    delete existingUserInfo.organization.id;
  }

  const updatedUserInfo = {
    ...existingUserInfo,
  };

  window.sessionStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
}

export const buildMedia = (companyId, id, mainImage, attachments) => {
  if (!companyId || !id) {
    console.error("Missing companyId or id");
    return null;
  }

  const baseUrl = `${attachment_URL}/${companyId}/sectionData/${id}`;

  const mainImageUrl = mainImage ? `${baseUrl}/${mainImage}` : null;

  const languageMap = { en: 1, fr: 2, ar: 3 };

  const attachmentsUrls =
    attachments?.map((attachment) => ({
      ...attachment,
      languageId: languageMap[attachment.languageId] || attachment.languageId,
      url: `${baseUrl}/${languageMap[attachment.languageId] || attachment.languageId}/${attachment.fileName}`,
    })) || [];

  return {
    mainImage: mainImageUrl,
    attachments: attachmentsUrls,
  };
};
